export default "__VITE_ASSET__DbKlA69Y__"